import React from 'react'

import { YStack } from '@mythical/ui'

import { ButtonLink } from '../primitive/Button'

interface Props {
  planLevel: number | 'free'
}

export const UpgradeButton = ({ planLevel }: Props) => {
  return (
    <YStack space="$2" jc="center" ai="center">
      <ButtonLink href={`/perks/${planLevel}`}>Upgrade now</ButtonLink>
    </YStack>
  )
}
